import { type Filter } from '@hungryroot/components-filters';
import { DietaryRestrictionsIdToTagsId } from '@hungryroot/dietary-restrictions';

/**
 * Matches `DietaryRestrictionsId` in `@hungryroot/dietary-restrictions`
 * (not exported from that package).
 */
const DietaryRestrictionsId = {
  Vegan: 1,
  Vegetarian: 2,
  Pescatarian: 3,
} as const;

const DIET_EXCLUDE_TAG_IDS_BY_QUERY_KEY: Record<string, readonly number[]> = {
  is_vegan: DietaryRestrictionsIdToTagsId[DietaryRestrictionsId.Vegan],
  is_vegetarian:
    DietaryRestrictionsIdToTagsId[DietaryRestrictionsId.Vegetarian],
  is_pescatarian:
    DietaryRestrictionsIdToTagsId[DietaryRestrictionsId.Pescatarian],
};

const COOK_TIME_QUERY_KEY = 'max_cooking_time';

export type CookbookFilterRequestParams = {
  tag_id?: number[];
  exclude_tag_id?: number[];
  max_cook_time?: number;
};

function appendUniqueTagIds(target: number[], ids: readonly number[]) {
  ids.forEach((id) => {
    if (!target.includes(id)) {
      target.push(id);
    }
  });
}

export function buildCookbookFilterRequestParams(
  selectedFilters: Filter[]
): CookbookFilterRequestParams {
  const tagIds: number[] = [];
  const excludeTagIds: number[] = [];
  let maxCookTime: number | undefined;

  selectedFilters.forEach((filter) => {
    if (filter.queryKey === COOK_TIME_QUERY_KEY && filter.queryValue) {
      const minutes = Number(filter.queryValue);
      if (!Number.isNaN(minutes)) {
        maxCookTime = minutes;
      }
      return;
    }

    if (
      filter.queryKey &&
      filter.queryKey in DIET_EXCLUDE_TAG_IDS_BY_QUERY_KEY
    ) {
      appendUniqueTagIds(
        excludeTagIds,
        DIET_EXCLUDE_TAG_IDS_BY_QUERY_KEY[filter.queryKey]
      );
      return;
    }

    if (filter.tag !== null && filter.tag !== undefined) {
      appendUniqueTagIds(tagIds, [filter.tag]);
    }
  });

  return {
    ...(tagIds.length > 0 ? { tag_id: tagIds } : {}),
    ...(excludeTagIds.length > 0 ? { exclude_tag_id: excludeTagIds } : {}),
    ...(maxCookTime !== undefined ? { max_cook_time: maxCookTime } : {}),
  };
}
